import ActivityInformation from './ActivityInformation'

export default ActivityInformation
